<div class="ui">
  <app-sidebar></app-sidebar>
  <div class="ui-content overflow-hidden vh-100">
    <div class="ui-content-scrolling scrolling">
      <div class="h-auto"> <!--  ???? serves the sticky???? -->
        <app-topbar></app-topbar>
        <router-outlet #ui=outlet></router-outlet>
      </div>
    </div>
  </div>
  <app-toolbar></app-toolbar>
</div>
